import { render, staticRenderFns } from "./PSUDateOfDelivery.vue?vue&type=template&id=17a95698&scoped=true&"
import script from "./PSUDateOfDelivery.vue?vue&type=script&lang=js&"
export * from "./PSUDateOfDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a95698",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
